import { useContext } from 'react'
import { GlobalContext } from '@/context'
import locale from '@/locale/locale'

function useLocale() {
  const { lang } = useContext(GlobalContext)
  return locale[lang]
}

export default useLocale
